// src/components/pages/dashboard/DashboardHome.tsx
'use client';

import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from 'src/components/common/ui/loader/LoadingSpinner';
import AudienceBarChart from 'src/components/pages/dashboard/AudienceBarChart';
import AudienceStats from 'src/components/pages/dashboard/AudienceStats';
import DashboardStats from 'src/components/pages/dashboard/DashboardStats';
import TopCreatives from 'src/components/pages/dashboard/TopCreatives';
import { AuthContext } from 'src/contexts';
import { useCampaign } from 'src/contexts/CampaignContext';
import { useDashboard } from 'src/contexts/DashboardContext';
import LaunchProject from './LaunchProject';

export default function DashboardHome() {
  const navigate = useNavigate();
  const { profile } = useContext(AuthContext);
  const { performanceData, genderStats, topAudience, topCreatives, isLoading } = useDashboard();
  const { campaigns } = useCampaign();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[80vh]">
        <LoadingSpinner />
      </div>
    );
  }


  // Show empty state if no campaigns
  if (!profile?.facebook || campaigns.length === 0) {
    return <LaunchProject />;
  }

  return (
    <div>
      <div className="flex justify-between items-center pb-4">
        <div>
          <p className="lg:text-[28px] text-[20px] font-semibold text-black font-inter">
            Generated leads
          </p>
          <p className="lg:block hidden text-base font-inter font-normal text-[#4A4D4F]">
            Your Performance Snapshot: Insights to Keep You on Track and Optimizing.
          </p>
        </div>

        {profile?.facebook !== null && (
          <button
            type="button"
            onClick={() => navigate('/dashboard/create-campaign')}
            className="bg-[#6277FF] text-white lg:px-4 px-3 lg:py-2 py-1.5 rounded-[10px] lg:text-base text-sm font-medium flex items-center"
          >
            <span className="lg:mr-2 mr-1">+</span> Create new campaign
          </button>
        )}
      </div>

      <p className="lg:hidden block text-sm font-inter font-normal text-[#4A4D4F]">
        Your Performance Snapshot: Insights to Keep You on Track and Optimizing.
      </p>

      <DashboardStats performanceData={performanceData} isLoading={isLoading} />
      <AudienceStats
        genderStats={genderStats}
        ageRangeStats={topAudience?.ageRanges}
        isLoading={isLoading}
      />
      <AudienceBarChart topAudience={topAudience} isLoading={isLoading} />
      <TopCreatives topCreatives={topCreatives} isLoading={isLoading} />
    </div>
  );
}
